/**
 * 存放公共枚举数据
 * **/
// import {
//   GetAllEnums
// } from '@/api/lbw'
const Enumeration = {
  state: {
    enumerationList: JSON.parse(localStorage.getItem('enumerationList')) || null
  },
  mutations: {
    setEnumeration(state, all) { //设置参数
      state.enumerationList = all;
    }
  },
  actions: {
    getEnumeration({
      commit
    }) { // 获取枚举列表
      // return new Promise((resolve, reject) => {
      //   GetAllEnums().then(response => {
      //     if (response.success) {
      //       commit('setEnumeration', response.result)
      //       localStorage.setItem('enumerationList', JSON.stringify(response.result))
      //       console.log('枚举-000000000000000000000', response.result)
      //       resolve(response)
      //     } else {
      //       reject(response.message)
      //     }
      //   }).catch(error => {
      //     reject(error)
      //   })
      // })
    },
  }
}

export default Enumeration